import React from 'react'

function Four04() {
  return (
    <div>
    <br/><br/>
    <h2>404</h2>
    <h2>the page you're looking for can't eb found</h2>
    </div>
  )
}

export default Four04